import { useQuery } from '@tanstack/react-query';
import { getAvailabilityById } from '../services/availabilityService';
import type { AvailabilityDocument } from '../models';
import { availabilityQueryKeys } from './availabilityQueryKeys';

interface UseAvailabilityQueryOptions {
  availabilityId?: string | null;
  enabled?: boolean;
}

export function useAvailabilityQuery({
  availabilityId,
  enabled = true,
}: UseAvailabilityQueryOptions): {
  data: AvailabilityDocument | null;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
} {
  const queryKey = availabilityId
    ? availabilityQueryKeys.detail(availabilityId)
    : availabilityQueryKeys.detail('new');

  const queryResult = useQuery<AvailabilityDocument | null>({
    enabled: Boolean(availabilityId) && enabled,
    queryKey,
    queryFn: async () => {
      if (!availabilityId) {
        return null;
      }

      return getAvailabilityById(availabilityId);
    },
    staleTime: 1000 * 60 * 5,
  });

  return {
    data: queryResult.data ?? null,
    isLoading: queryResult.isLoading,
    isError: queryResult.isError,
    error: queryResult.error as Error | null,
  };
}
